export function OutlineBill1Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.387 7H3.38696V16.9984H21.387V7Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.987 16.9984H5.78696C5.78696 15.6736 4.71176 14.5984 3.38696 14.5984V9.4C4.71176 9.4 5.78696 8.3248 5.78696 7H18.987C18.987 8.3248 20.0622 9.4 21.387 9.4V14.5984C20.0622 14.5984 18.987 15.6736 18.987 16.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3868 13.0007C12.9382 13.0007 13.3852 12.5537 13.3852 12.0023C13.3852 11.4509 12.9382 11.0039 12.3868 11.0039C11.8354 11.0039 11.3884 11.4509 11.3884 12.0023C11.3884 12.5537 11.8354 13.0007 12.3868 13.0007Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
